import { defineComponent, h } from '@vue/composition-api';
import { withInstall } from '../util';
import "../style/components/navbar.css";
var userAgent = navigator.userAgent;
var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
/**
 * "Mozilla/5.0 (Linux; Android 10; PCLM50 Build/QKQ1.200216.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/79.0.3999.119 KsWebView/1.6.79.156 Mobile Safari/537.36
 * Yoda/2.4.1-rc1 NetType/WIFI StatusHT/32 Kwai/9.2.40.99999 OS_PRO_BIT/64 MAX_PHY_MEM/7411 TitleHT/50 AllowKsCallApp CT/0"
 */

var statusBarHeight = (userAgent.match(/.*StatusHT\/(\d+).*/) || [userAgent, 0])[1];
var Navbar = defineComponent({
  name: 'm-navbar',
  props: {
    left: {
      type: String,
      "default": ''
    },
    title: {
      type: String,
      "default": ''
    },
    right: {
      type: String,
      "default": ''
    },
    fixed: {
      type: Boolean,
      "default": false
    },
    placeholder: {
      type: Boolean,
      "default": false
    },
    round: {
      type: Boolean,
      "default": false
    },
    safeAreaInsetTop: {
      type: Boolean,
      "default": false
    }
  },
  slots: ['left', 'title', 'right'],
  emits: ['left', 'title', 'right'],
  setup: function setup(props, context) {
    return function () {
      var left;

      if (props.left) {
        left = h("div", {
          "class": "left__text"
        }, [props.left]);
      } else {
        var _context$slots$left, _context$slots;

        left = (_context$slots$left = (_context$slots = context.slots).left) === null || _context$slots$left === void 0 ? void 0 : _context$slots$left.call(_context$slots);
      }

      var title;

      if (props.title) {
        title = h("div", {
          "class": "title__text"
        }, [props.title]);
      } else {
        var _context$slots$title, _context$slots2;

        title = (_context$slots$title = (_context$slots2 = context.slots).title) === null || _context$slots$title === void 0 ? void 0 : _context$slots$title.call(_context$slots2);
      }

      var right;

      if (props.right) {
        right = h("div", {
          "class": "right__text"
        }, [props.right]);
      } else {
        var _context$slots$right, _context$slots3;

        right = (_context$slots$right = (_context$slots3 = context.slots).right) === null || _context$slots$right === void 0 ? void 0 : _context$slots$right.call(_context$slots3);
      }

      var style = isAndroid && props.safeAreaInsetTop ? {
        paddingTop: "".concat(statusBarHeight, "px")
      } : {};
      return h("div", {
        "class": {
          'm-navbar': true,
          'safe-area-inset-top': props.safeAreaInsetTop
        }
      }, [h("div", {
        "class": {
          'm-navbar-box': true,
          fixed: props.fixed,
          round: props.round
        },
        "style": style
      }, [left && h("div", {
        "class": "left",
        "on": {
          "click": function click() {
            return context.emit('left');
          }
        }
      }, [left]), title && h("div", {
        "class": "title",
        "on": {
          "click": function click() {
            return context.emit('title');
          }
        }
      }, [title]), right && h("div", {
        "class": "right",
        "on": {
          "click": function click() {
            return context.emit('right');
          }
        }
      }, [right])]), props.fixed && props.placeholder && h("div", {
        "class": "m-navbar-holder",
        "style": style
      })]);
    };
  }
});
withInstall(Navbar);
export default Navbar;